import axios from 'axios'
import { EnvConfig } from '../../config/EnvConfig'

const HTTP_TIMEOUT = 30000

const kambiAuthApi = axios.create({
  baseURL: EnvConfig.GATSBY_KAMBI_AUTH_API,
  timeout: HTTP_TIMEOUT,
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
})

export default kambiAuthApi
